module.exports = __webpack_public_path__ + "img/product-list-bj.bc9bf628.png";